/**
 * fetchWithRetry
 *
 * fetches the data from the API and retries if it fails
 *
 * @param url - url to fetch
 * @param options - options to pass to the fetch
 * @param retries - number of retries
 * @returns data from the API
 */
export function fetchWithRetry(url: string, options = {}, retries = 3) {
    return fetch(url, options).then(res => {
      if (!res.ok) throw new Error('Fetch failed');
      return res.json();
    }).catch(err => {
      if (retries > 0) return fetchWithRetry(url, options, retries - 1);
      throw err;
    });
}